/** Fecha contable (date-only UTC) → dd/mm/aaaa sin corrimiento por huso. */
export function formatAccountingDate(value?: string | Date | null): string {
  if (value == null || value === '') return '—';
  const d = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('es-AR', { timeZone: 'UTC' });
}

/** Primer y último día del mes calendario anterior (YYYY-MM-DD, UTC). */
export function lastMonthRange(now = new Date()): { dateFrom: string; dateTo: string } {
  const y = now.getFullYear();
  const m = now.getMonth(); // 0-based current month
  const from = new Date(Date.UTC(y, m - 1, 1));
  const to = new Date(Date.UTC(y, m, 0));
  return {
    dateFrom: from.toISOString().slice(0, 10),
    dateTo: to.toISOString().slice(0, 10),
  };
}
